import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { Nav, Navbar, Container } from 'react-bootstrap';
import TestComponent from './test/Test';
import GenerateInvoice from './components/GenerateInvoice';
import logo from './optica.png';
import './App.css';

const NAV_ITEMS = [
    { to: '/', label: 'Accueil', end: true },
    { to: '/generate_slip', label: 'Bordereaux' },
    { to: '/generate_invoice', label: 'Factures' },
    { to: '/test', label: 'Test' },
];

const App = () => {
    return (
        <Router>
            <div className="app-shell">
                <Navbar bg="light" expand="lg" className="app-navbar" sticky="top">
                    <Container fluid className="px-0">
                        <Navbar.Brand as={NavLink} to="/" className="app-brand">
                            <span className="app-brand-mark">
                                <img src={logo} alt="" />
                            </span>
                            <span>
                                MVP
                            </span>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="main-nav" />
                        <Navbar.Collapse id="main-nav">
                            <Nav className="ms-auto app-nav">
                                {NAV_ITEMS.map((item) => (
                                    <Nav.Link
                                        key={item.to}
                                        as={NavLink}
                                        to={item.to}
                                        end={item.end}
                                    >
                                        {item.label}
                                    </Nav.Link>
                                ))}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>

                <main className="app-main">
                    <Routes>
                        <Route path="/" element={<MainPage />} />
                        <Route path="/generate_invoice" element={<MainPage />} />
                        <Route path="/test" element={<TestComponent />} />
                        {/* Add more routes as needed */}
                    </Routes>
                </main>
            </div>
        </Router>
    );
};

const MainPage = () => <GenerateInvoice />;

export default App;
